import {
  Account,
  id,
  Identifiable,
  Project,
  ProjectResource,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource } from "../linkers/types";

type ProjectMembersResponse = {
  _embedded: {
    projectMembers: LinkedResource<Identifiable<ProjectResource>>[];
  };
};

function getProjectRole(httpClient: HttpClient) {
  return (account: Identifiable<Account>, project: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<ProjectMembersResponse>({
        endpoint: `/projectMembers/search/rsql?query=member.uuid=="${account.resource.uuid}" and project.uuid=="${project.uuid}"&projection=details`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => _embedded.projectMembers)
      .then((promises) => Promise.all(promises))
      .then(([ressource]) => ressource)
      .then(({ role }) => ({ ...role, uuid: id }));
}

export { getProjectRole };
